import FriendlyTime from "~/components/shared/FriendlyTime";
import UserAvatar from "~/components/shared/UserAvatar";
import Emojify from "~/components/shared/Emojify";

export type PausedClusterQueue = {
  key: string;
  path: string;
  dispatchPausedAt: string;
  dispatchPausedBy: {
    name: string;
    avatar: {
      url: string;
    };
  };
  dispatchPausedNote?: string | null;
};

function PausedQueueNote({ note }: { note?: string | null }) {
  if (note == null || note.length === 0) {
    return null;
  }

  return (
    <div className="mb-5 mt-2">
      <p className="px5 depth rounded-1.5 charcoal-800 m-0 inline-block bg-white py-5">
        <Emojify text={note} />
      </p>
    </div>
  );
}

function PausedQueueDetails({ queue }: { queue: PausedClusterQueue }) {
  return (
    <div className="charcoal-500 mt-4 border-gray-400 pt-4 first:mt-0 first:pt-0" role="listitem">
      <div className="gap2 flex">
        <a className="color-inherit underline" href={queue.path}>
          {queue.key}
        </a>

        <span className="parsnip-400">&bull;</span>

        <span className="gap1 flex items-center">
          <UserAvatar user={queue.dispatchPausedBy} size="MICRO" />
          {queue.dispatchPausedBy.name}
        </span>

        <span className="parsnip-400">&bull;</span>

        <FriendlyTime value={queue.dispatchPausedAt} capitalized={true} />
      </div>

      <PausedQueueNote note={queue.dispatchPausedNote} />
    </div>
  );
}

export default function PausedClusterQueuesNotice({
  pausedQueues,
}: {
  pausedQueues: Array<PausedClusterQueue>;
}) {
  if (!pausedQueues || pausedQueues.length === 0) {
    return null;
  }

  return (
    <div className="p6 rounded-1.5 border-parsnip-400 bg-parsnip-100 mb-2 border pb-0 antialiased">
      <h2 className="charcoal-900 m-0 mb-3" style={{ fontSize: 16 }}>
        {pausedQueues.length > 1 ? `${pausedQueues.length} Queues Paused` : "Queue Paused"}
      </h2>

      <div className="mb-6 divide-y" role="list">
        {pausedQueues.map((queue) => (
          <PausedQueueDetails key={queue.key} queue={queue} />
        ))}
      </div>
    </div>
  );
}
